import * as React from 'react';

/* View-only columns of cards. No drag: moving a card would be a write. */

export interface BoardColumn {
    key: string;
    label: string;
    tone?: string;
    count: number;
    children: React.ReactNode;
    empty?: string;
}

export function Board({ columns, label }: { columns: BoardColumn[]; label: string }) {
    return (
        <div className="board" role="list" aria-label={label}>
            {columns.map((c) => (
                <section key={c.key} className={`board-col${c.count === 0 ? ' empty' : ''}`} role="listitem" aria-label={`${c.label}, ${c.count}`}>
                    <div className="board-h">
                        <span className="tone" style={c.tone ? { background: c.tone } : undefined} />
                        {c.label}
                        <span className="c">{c.count}</span>
                    </div>
                    <div className="board-list">
                        {c.count === 0 ? <p className="board-empty">{c.empty ?? 'Nothing here'}</p> : c.children}
                    </div>
                </section>
            ))}
        </div>
    );
}

export function BoardCard({
    name,
    meta,
    foot,
    href,
    onOpen,
    navigate,
}: {
    name: React.ReactNode;
    meta?: React.ReactNode;
    foot?: React.ReactNode;
    href?: string;
    onOpen?: () => void;
    navigate?: (href: string) => void;
}) {
    const body = (
        <>
            <span className="n">{name}</span>
            {meta && <span className="m">{meta}</span>}
            {foot && <span className="f">{foot}</span>}
        </>
    );
    if (href)
        return (
            <a
                className="board-card"
                href={href}
                onClick={(e) => {
                    if (e.metaKey || e.ctrlKey || !navigate) return;
                    e.preventDefault();
                    navigate(href);
                }}
            >
                {body}
            </a>
        );
    return (
        <button type="button" className="board-card" onClick={onOpen}>
            {body}
        </button>
    );
}
